import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Card, Button } from '../model/card-buttons.model';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  public allCards: Card[] = [
    // --- GOBIERNO ---
    { title: 'Seguimiento PaP', content: 'Seguimiento del avance del pase de fin de semana.', link: '/Gob/PaP', extraClass: '', department: 'Gobierno', imgSource: "/assets/images/tools/seguimientoPap.webp", requiredGroups: [] },

    { title:'CAB', content:'CAB semanal', link:'/Gob/CAB', extraClass:'', department:'Gobierno', imgSource:"/assets/images/tools/cab.webp", requiredGroups: ['grpGeddisGob'] },

    // { title: 'PMC', content: 'Nucleo central del control de proyectos en Jira software   (Overwatch) y Redmine (Minetrack)', link: '/Gob/PMC', extraClass: '', department: 'Gobierno', imgSource: "/assets/images/tools/PMC.webp", requiredGroups: [] },
    { title: 'PMC', content: 'Nucleo central del control de proyectos en Jira software   (Overwatch)', link: '/Gob/PMC', extraClass: '', department: 'Gobierno', imgSource: "/assets/images/tools/PMC.webp", requiredGroups: [] },

    { title: 'Consulta de JIRA', content: 'Sección de búsqueda de Jiras.', link: '/Gob/Jiras', extraClass: '', department: 'Gobierno', imgSource: "/assets/images/tools/jira-1.svg", requiredGroups: [] },

    // --- SERVICIO ---
    { title:'Seguimiento Backlog', content:'Objetivos de Backlog y Aged - KPIs.', link:'/Serv/Backlog', extraClass:'', department:'Servicio', imgSource:'/assets/images/tools/backlog.svg', requiredGroups:[] },

    { title: 'Calendario Diario', content: 'Calendarios de intervenciones diarias.', link: '', extraClass: 'noLink', department: 'Servicio', imgSource: "/assets/images/tools/calendarios.webp", requiredGroups: [] },

    { title: 'Calendario Guardias', content: 'Calendarios de guardias.', link: '', extraClass: 'noLink', department: 'Servicio', imgSource: "/assets/images/tools/calendarios.webp", requiredGroups: [] },

    { title: 'Calendario PaPs', content: 'Calendarios Ventanas PaP.', link: '', extraClass: 'noLink', department: 'Gobierno', imgSource: "/assets/images/tools/calendarios.webp", requiredGroups: [] },

    { title: 'Comunicado CAU', content: 'Comunicado CAU', link: '/Serv/ComunicadoCAU', extraClass: '', department: 'Servicio', imgSource: "/assets/images/tools/comunicadoCAU.webp", requiredGroups: ['grpGeddisAdmin', 'grpGeddisGob', 'grpGeddisServ']},

    {
      title:'Calculadora CAU',content:'Calculadora de prioridades para incidencias',link:'/Serv/CalculadoraCAU',extraClass:'',department:'Servicio',imgSource:"/assets/images/tools/calculadoraCAU.webp",requiredGroups:[]
    },
/*     {
      title:'PSE',content:'Propuesta de soporte extraordinario',link:'/Serv/PSE',extraClass:'',department:'Servicio',imgSource:"/assets/images/tools/pss.webp",requiredGroups:[]
    }, */

    // --- INFRAESTRUCTURA ---
    { title:'Sentinel', content:'Monitorización y seguimiento de certificados', link:'/Infra/Sentinel', extraClass:'', department:'Infraestructura', imgSource:"/assets/images/tools/sentinel.webp", requiredGroups:['grpGeddisInfra'] },
    { title:'FinOps',content:'Control de los gastos de infraestructura',link:'/Infra/FinOps',extraClass:'',department:'Infraestructura',imgSource:"/assets/images/tools/finops.webp",requiredGroups:['grpGeddisInfra']},
  ];

  public allButtons: Button[] = [
    { text: 'Calendario - RFCs', link: "https://calendar.google.com/calendar/embed?src=c_305420285e241ed9c331c755d318dc7c1f8e07b1a7860735bb51f0f9a69cbcbe%40group.calendar.google.com&ctz=Europe%2FMadrid", condition: 'Calendario Diario', requiredGroups:[] },
    { text: 'Calendario - CSI-RFCs', link: "https://calendar.google.com/calendar/embed?src=c_4a1249d3936f777fcb9d7875ac7b53185bf4c01701ec65ab2b52f5b1471ea48e%40group.calendar.google.com&ctz=Europe%2FMadrid", condition: 'Calendario Diario', requiredGroups:[] },
    { text: 'Calendario - Guardias', link: "https://calendar.google.com/calendar/u/0/embed?src=c_a30ca023d46c87f13bace6f573e1a8baaad78c339a4616fdf72616a8c407a4ed@group.calendar.google.com&ctz=Europe/Madrid", condition: 'Calendario Guardias', requiredGroups:[] },
    { text: 'Calendario - PaPs', link: "https://docs.google.com/spreadsheets/d/1da1WSSg65VzXRHsIGYlo6i341giEEXjY4_bW1fD8Nk0/edit?gid=534321798#gid=534321798", condition: 'Calendario PaPs', requiredGroups:[] },
  ];

  public allDepartments: string[] = [
    'Gobierno',
    'Explotación',
    'Devops - Desarrollo',
    'Infraestructura',
    'Servicio',
  ];


  private authorizedCardsSubject = new BehaviorSubject<Card[]>([]);
  private authorizedButtonsSubject = new BehaviorSubject<Button[]>([]);

  public authorizedCards$ = this.authorizedCardsSubject.asObservable();
  public authorizedButtons$ = this.authorizedButtonsSubject.asObservable();

  constructor() { }

  // ======================================================
  // 4. MÉTODOS PÚBLICOS PARA MOSTRAR SOLO LAS CARTAS AUTORIZADAS
  // ======================================================

  public getCardsByDepartment(department: string): Card[] {
    const allAuthorizedCards = this.authorizedCardsSubject.getValue();
    return allAuthorizedCards.filter(card => card.department === department);
  }

  public setAuthorizedCards(cards: Card[]): void {
    this.authorizedCardsSubject.next(cards);
  }

  public setAuthorizedButtons(buttons: Button[]): void {
    this.authorizedButtonsSubject.next(buttons);
  }
}
